import React from "react";

const LoaderComponent = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default LoaderComponent;
